module.exports = __webpack_public_path__ + "static/errecb905c845c3920a82b163c7447b9668.png";